import { formatted_number } from 'helpers/number'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

function AuctionInformation({ auction, facility }) {
    return (
        <Row>
            <Col>
                <div>
                    <strong>Auction Location: </strong>
                    {`${auction?.facility?.city}, ${auction?.facility?.state}`}
                </div>
                <div>
                    <strong>Approx. Size: </strong>
                    {' '}
                    {`${auction?.unit_width} x ${auction?.unit_length}`}
                </div>
                <div>
                    <strong>Cleaning Deposit: </strong>
                    {' '}
                    {formatted_number(auction?.cleaning_deposit)}
                </div>
            </Col>
            <Col>
                <div>
                    <strong>Cleanout Time: </strong>
                    {' '}
                    {auction?.cleanout_time}
                    {' '}
                    Hrs
                </div>
                <div>
                    <strong>Sales Tax: </strong>
                    {' '}
                    {auction?.sales_tax}
                    %
                </div>

                {!facility?.payment_options ? null : (
                    <div>
                        <strong>Payment Options: </strong>
                        {' '}
                        {facility?.payment_options}
                    </div>
                )}
            </Col>
            <Col sm={12} className="auction-contains-wrapper">
                <div className="auction-contains">Unit Appears to Contain:</div>
                <div className="auction-contains-info">{auction?.unit_contents}</div>
            </Col>
        </Row>
    )
}

export default AuctionInformation
